import React from "react";

import { BlockTitle } from "../../Component";
import VacancyFieldBlock from "./VacancyFieldBlock";

const FIELDS = [
  { field: "arguments", label: "What we offer", addButtonTitle: "Add offer" },
  {
    field: "qualification",
    label: "Qualification",
    addButtonTitle: "Add qualification",
  },
  { field: "experience", label: "Experience", addButtonTitle: "Add experience" },
  { field: "skills", label: "Skills", addButtonTitle: "Add skill" },
];

const VacancyRequirementsBlock = () => (
  <div className="mt-4">
    <BlockTitle tag="h5" className="mb-3">
      Requirements
    </BlockTitle>

    {FIELDS.map(({ field, label, addButtonTitle }) => (
      <VacancyFieldBlock
        key={field}
        label={label}
        isList
        addButtonTitle={addButtonTitle}
        getInitial={(normalized) => normalized[field]}
        getSaved={(vacancy) => vacancy?.[field]}
        buildPatch={(value) => ({ [field]: value })}
      />
    ))}
  </div>
);

export default VacancyRequirementsBlock;
